import { Controller } from "stimulus"

export default class extends Controller {
  async testConnection(event) {
    event.preventDefault()

    const button = event.currentTarget
    const url = button.dataset.url
    const urlField = document.getElementById('workday_integration_url')
    const usernameField = document.getElementById('workday_integration_username')
    const passwordField = document.getElementById('workday_integration_password')

    if (!urlField.value || !usernameField.value || !passwordField.value) {
      document.getElementById('connection_status').innerHTML = '<span class="text-danger"><i class="fas fa-times-circle"></i> Please fill in all credential fields</span>'
      return
    }

    button.disabled = true
    button.innerHTML = 'Testing...'

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
          'Accept': 'text/vnd.turbo-stream.html'
        },
        body: new URLSearchParams({
          url: urlField.value,
          username: usernameField.value,
          password: passwordField.value
        })
      })

      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } catch (error) {
      document.getElementById('connection_status').innerHTML = `<span class="text-danger"><i class="fas fa-times-circle"></i> ${error.message}</span>`
    } finally {
      button.disabled = false
      button.innerHTML = 'Test Connection'
    }
  }
}
